// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2xU8R","dragIcon":"SortableItem_dragIcon__2s2RW","disabled":"SortableItem_disabled__8roAj"};